<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="-10 0 532 512"
    class="icon tailor"
  >
    <g transform="translate(2)" id="g1328" class="pin-base">
      <path
        d="m 469.05368,432.15388 c 8.96822,-0.65013 16.7213,2.6133 23.15249,7.83989 6.43127,5.22659 9.64686,11.4985 9.64686,18.81572 0,7.31723 -3.21559,13.58913 -9.64686,18.81573 -6.43119,5.22659 -14.14868,7.83988 -23.15249,7.83988 H 40.732839 c -9.00371,0 -16.72121,-2.61329 -23.15248,-7.83988 -6.43128,-5.2266 -9.6468599,-11.4985 -9.6468599,-18.81573 0,-7.31722 3.2155799,-13.58913 9.6468599,-18.81572 6.43127,-5.22659 9.44206,-7.85266 23.15248,-7.83989 17.35317,0.0956 414.747611,0.62922 428.320841,0 z"
      />
      <path
        d="m 40.177099,431.02716 c 17.32443,-97.02869 90.199081,-182.73489 213.715291,-186.89305 125.76181,1.71651 198.49412,92.84641 214.82066,186.89305 -299.12581,-1.01561 -356.29828,-2.05661 -428.535951,0 z"
      />
    </g>
    <g transform="translate(2)" id="g1320" class="pin-left">
      <path d="m 134.14544,206.71653 35.03812,52.07271" />
      <path
        d="m 117.01818,156.50668 c 15.6075,0.64241 24.2375,10.33377 25.1817,25.79862 -0.2594,16.08456 -10.0073,25.31714 -25.1817,25.79899 -13.7971,-0.50226 -23.826101,-10.91202 -24.283301,-25.79881 0.4563,-15.36216 9.593701,-25.32801 24.283301,-25.7988 z"
      />
    </g>
    <g
      id="g1161-0"
      transform="translate(1840.2885,424.19025)"
      class="pin-middle"
    >
      <path
        d="m -1582.6842,-395.57414 c -15.5762,1.1785 -23.868,11.16078 -24.2801,26.64895 0.8122,16.06614 10.8716,24.9582 26.0536,24.91818 13.7717,-0.9762 23.437,-11.72454 23.3822,-26.61825 -0.9841,-15.33739 -10.4586,-24.98329 -25.1557,-24.94888 z"
      />
      <path d="m -1581.54,-336.16307 -0.7221,149.98658" />
    </g>
    <g transform="translate(2)" id="g1324" class="pin-right">
      <path
        d="m 406.08399,117.92011 c 15.6075,0.64241 24.2375,10.33378 25.1817,25.79863 -0.2594,16.08456 -10.0073,25.31714 -25.1817,25.79899 -13.7971,-0.50226 -23.8261,-10.91202 -24.2833,-25.79881 0.4563,-15.36216 9.5937,-25.32802 24.2833,-25.79881 z"
      />
      <path d="m 387.72303,171.32612 -57.40351,79.7976" />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.icon.tailor {
  width: 2.3em;
  height: 2.3em;
  stroke-width: 20pt;
  stroke-dasharray: 1000;
}

.menu__item.router-link-active .icon {
  &.tailor {
    .pin-base {
      animation: strokeTailor 0.4s reverse;
    }
    .pin-left {
      transform: translate(-55px, -50px);
      animation: move-left-pin 0.5s forwards;
      animation-delay: 0.5s;
    }
    .pin-right {
      transform: rotateZ(-16deg);
      animation: move-right-pin 0.5s forwards;
      animation-delay: 0.75s;
    }
  }

  @keyframes strokeTailor {
    100% {
      stroke-dashoffset: 950;
    }
  }

  @keyframes move-middle-pin {
    0% {
      transform: translateY(-50px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  @keyframes move-left-pin {
    0% {
      transform: translate(-55px, -50px);
    }
    100% {
      transform: translate(0px, 0px);
    }
  }

  @keyframes move-right-pin {
    0% {
      transform: rotateZ(-16deg);
    }
    100% {
      transform: rotateZ(0deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/svgs/SvgTailor.vue